module.exports = __webpack_public_path__ + "img/size1_en.d450c778.png";